import initialState from "../../core/reducers/initialState";
import {
  COMMUNITY_CONFIGS_LOADING,
  COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING,
  COMMUNITY_OWNERSHIPS_LOADING, COMMUNITY_STATISTICS_LOADING,
  LOAD_COMMUNITY_CONFIGS_SUCCESS,
  LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS,
  LOAD_COMMUNITY_OWNERSHIPS_SUCCESS,
  LOAD_COMMUNITY_STATISTICS_SUCCESS,
  LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS, MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING
} from "../actions/actionTypes";

export default function communitiesReducer(state = initialState.communities, action: any) {
  switch (action.type) {
    case LOAD_COMMUNITY_OWNERSHIPS_SUCCESS:
      return {
        ...state,
        communityOwnerships: action.communityOwnerships
      }
    case LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        communityMemberships: {
          ...action.communityMemberships,
          canLoadMore: action.communityMemberships.items.length === action.communityMemberships._page.pageSize
        }
      }
    case LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        communityMemberships: {
          _page: action.communityMemberships._page,
          items: state.communityMemberships.items.concat(action.communityMemberships.items),
          canLoadMore: action.communityMemberships.items.length === action.communityMemberships._page.pageSize
        }
      }
    case LOAD_COMMUNITY_CONFIGS_SUCCESS:
      return {
        ...state,
        communityConfigs: action.communityConfigs
      }
    case LOAD_COMMUNITY_STATISTICS_SUCCESS:
      return {
        ...state,
        communityStatistics: action.communityStatistics
      }
    case COMMUNITY_OWNERSHIPS_LOADING:
      return {
        ...state,
        communityOwnershipsLoading: action.loading
      }
    case COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING:
      return {
        ...state,
        communityManagementMembershipsLoading: action.loading
      }
    case MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING:
      return {
        ...state,
        moreCommunityManagementMembershipsLoading: action.loading
      }
    case COMMUNITY_CONFIGS_LOADING:
      return {
        ...state,
        communityConfigsLoading: action.loading
      }
    case COMMUNITY_STATISTICS_LOADING:
      return {
        ...state,
        communityStatisticsLoading: action.loading
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/core/reducers/communitiesReducer.ts